import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M0 20c0 7.58 4.218 14.176 10.435 17.568V2.432C4.218 5.824 0 12.419 0 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#496E2D",
  d: "M20 0c-3.465 0-6.724.882-9.565 2.432v35.136A19.91 19.91 0 0 0 20 40c11.046 0 20-8.954 20-20S31.046 0 20 0Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M28.55 23.308a5.652 5.652 0 1 1-4.043-10.187 6.957 6.957 0 1 0 5.825 8.062 5.626 5.626 0 0 1-1.781 2.125Zm-.108-10.264 1.426 1.536 1.901-.88-1.02 1.83 1.425 1.535-2.056-.405-1.02 1.83-.25-2.08-2.057-.405 1.902-.88-.25-2.081Z"
}, null, -1), d = [
  n,
  c,
  s,
  i
];
function _(a, h) {
  return e(), l("svg", o, [...d]);
}
const p = { render: _ };
export {
  p as default,
  _ as render
};
